export const TRADES: Record<string, string> = {
  plumbing: "Plumber",
  electrical: "Electrician",
  carpentry: "Carpenter",
  roofing: "Roofer",
  hvac: "HVAC Technician",
  painting: "Painter",
  flooring: "Flooring Installer",
  landscaping: "Landscaper",
  masonry: "Mason",
  concrete: "Concrete Worker",
  construction: "Construction Company",
  drywall: "Drywall Installer",
  tiling: "Tile Installer",
  welding: "Welder",
  plasterwork: "Plasterer",
  mechanic: "Mechanic",
  general: "General Contractor",
}

/** Trade options for use in <select> dropdowns — derived from TRADES to stay in sync. */
export const TRADE_OPTIONS = Object.entries(TRADES).map(([slug, label]) => ({
  value: slug,
  label,
}))

export const LOCATIONS: Record<string, { name: string; state: string }> = {
  "los-angeles": { name: "Los Angeles", state: "CA" },
  "new-york": { name: "New York", state: "NY" },
  chicago: { name: "Chicago", state: "IL" },
  houston: { name: "Houston", state: "TX" },
  phoenix: { name: "Phoenix", state: "AZ" },
  philadelphia: { name: "Philadelphia", state: "PA" },
  "san-antonio": { name: "San Antonio", state: "TX" },
  "san-diego": { name: "San Diego", state: "CA" },
  dallas: { name: "Dallas", state: "TX" },
  "san-jose": { name: "San Jose", state: "CA" },
  austin: { name: "Austin", state: "TX" },
  jacksonville: { name: "Jacksonville", state: "FL" },
  "fort-worth": { name: "Fort Worth", state: "TX" },
  columbus: { name: "Columbus", state: "OH" },
  charlotte: { name: "Charlotte", state: "NC" },
  indianapolis: { name: "Indianapolis", state: "IN" },
  "san-francisco": { name: "San Francisco", state: "CA" },
  seattle: { name: "Seattle", state: "WA" },
  denver: { name: "Denver", state: "CO" },
  nashville: { name: "Nashville", state: "TN" },
  miami: { name: "Miami", state: "FL" },
  atlanta: { name: "Atlanta", state: "GA" },
  "las-vegas": { name: "Las Vegas", state: "NV" },
  portland: { name: "Portland", state: "OR" },
  minneapolis: { name: "Minneapolis", state: "MN" },
  boston: { name: "Boston", state: "MA" },
  "el-paso": { name: "El Paso", state: "TX" },
  detroit: { name: "Detroit", state: "MI" },
  memphis: { name: "Memphis", state: "TN" },
  "kansas-city": { name: "Kansas City", state: "MO" },

  // ── Tier 2 — mid-size metros ──────────────────────────────────────────────
  raleigh: { name: "Raleigh", state: "NC" },
  tampa: { name: "Tampa", state: "FL" },
  orlando: { name: "Orlando", state: "FL" },
  sacramento: { name: "Sacramento", state: "CA" },
  tucson: { name: "Tucson", state: "AZ" },
  omaha: { name: "Omaha", state: "NE" },
  albuquerque: { name: "Albuquerque", state: "NM" },
  fresno: { name: "Fresno", state: "CA" },
  "colorado-springs": { name: "Colorado Springs", state: "CO" },
  "virginia-beach": { name: "Virginia Beach", state: "VA" },
  richmond: { name: "Richmond", state: "VA" },
  bakersfield: { name: "Bakersfield", state: "CA" },
  tulsa: { name: "Tulsa", state: "OK" },
  aurora: { name: "Aurora", state: "CO" },
  "baton-rouge": { name: "Baton Rouge", state: "LA" },
  lexington: { name: "Lexington", state: "KY" },
  stockton: { name: "Stockton", state: "CA" },
  "corpus-christi": { name: "Corpus Christi", state: "TX" },
  "st-louis": { name: "St. Louis", state: "MO" },
  cincinnati: { name: "Cincinnati", state: "OH" },
  pittsburgh: { name: "Pittsburgh", state: "PA" },
  greensboro: { name: "Greensboro", state: "NC" },
  plano: { name: "Plano", state: "TX" },
  henderson: { name: "Henderson", state: "NV" },
  lincoln: { name: "Lincoln", state: "NE" },
  buffalo: { name: "Buffalo", state: "NY" },
  riverside: { name: "Riverside", state: "CA" },
  "st-paul": { name: "St. Paul", state: "MN" },
  louisville: { name: "Louisville", state: "KY" },
  "new-orleans": { name: "New Orleans", state: "LA" },
  cleveland: { name: "Cleveland", state: "OH" },
  milwaukee: { name: "Milwaukee", state: "WI" },
  "oklahoma-city": { name: "Oklahoma City", state: "OK" },
  "salt-lake-city": { name: "Salt Lake City", state: "UT" },
  "fort-lauderdale": { name: "Fort Lauderdale", state: "FL" },
  "jersey-city": { name: "Jersey City", state: "NJ" },
  "st-petersburg": { name: "St. Petersburg", state: "FL" },
  norfolk: { name: "Norfolk", state: "VA" },
  laredo: { name: "Laredo", state: "TX" },
  madison: { name: "Madison", state: "WI" },
  durham: { name: "Durham", state: "NC" },
  "winston-salem": { name: "Winston-Salem", state: "NC" },
  "fort-wayne": { name: "Fort Wayne", state: "IN" },
  lubbock: { name: "Lubbock", state: "TX" },
  chandler: { name: "Chandler", state: "AZ" },
  scottsdale: { name: "Scottsdale", state: "AZ" },
  mesa: { name: "Mesa", state: "AZ" },
  "glendale-az": { name: "Glendale", state: "AZ" },
  garland: { name: "Garland", state: "TX" },

  // ── Tier 3 — smaller cities / high-intent suburbs ─────────────────────────
  boise: { name: "Boise", state: "ID" },
  spokane: { name: "Spokane", state: "WA" },
  "des-moines": { name: "Des Moines", state: "IA" },
  oxnard: { name: "Oxnard", state: "CA" },
  fayetteville: { name: "Fayetteville", state: "NC" },
  fremont: { name: "Fremont", state: "CA" },
  irvine: { name: "Irvine", state: "CA" },
  "chula-vista": { name: "Chula Vista", state: "CA" },
  tempe: { name: "Tempe", state: "AZ" },
  gilbert: { name: "Gilbert", state: "AZ" },
  "moreno-valley": { name: "Moreno Valley", state: "CA" },
  "grand-rapids": { name: "Grand Rapids", state: "MI" },
  "little-rock": { name: "Little Rock", state: "AR" },
  knoxville: { name: "Knoxville", state: "TN" },
  worcester: { name: "Worcester", state: "MA" },
  akron: { name: "Akron", state: "OH" },
  "cape-coral": { name: "Cape Coral", state: "FL" },
  huntsville: { name: "Huntsville", state: "AL" },
  "garden-grove": { name: "Garden Grove", state: "CA" },
  "santa-rosa": { name: "Santa Rosa", state: "CA" },
  chattanooga: { name: "Chattanooga", state: "TN" },
  "fort-collins": { name: "Fort Collins", state: "CO" },
  "west-valley": { name: "West Valley City", state: "UT" },
  "huntington-beach": { name: "Huntington Beach", state: "CA" },
  "glendale-ca": { name: "Glendale", state: "CA" },
  providence: { name: "Providence", state: "RI" },
  "san-bernardino": { name: "San Bernardino", state: "CA" },
  "overland-park": { name: "Overland Park", state: "KS" },
  "grand-prairie": { name: "Grand Prairie", state: "TX" },
  "santa-clarita": { name: "Santa Clarita", state: "CA" },
  "newport-news": { name: "Newport News", state: "VA" },
  "elk-grove": { name: "Elk Grove", state: "CA" },
  "peoria-az": { name: "Peoria", state: "AZ" },
  salem: { name: "Salem", state: "OR" },
  "eugene-or": { name: "Eugene", state: "OR" },
  "tallahassee": { name: "Tallahassee", state: "FL" },
  "shreveport": { name: "Shreveport", state: "LA" },
  "sioux-falls": { name: "Sioux Falls", state: "SD" },
  "springfield-mo": { name: "Springfield", state: "MO" },
  "springfield-ma": { name: "Springfield", state: "MA" },
  "ontario-ca": { name: "Ontario", state: "CA" },
  "rancho-cucamonga": { name: "Rancho Cucamonga", state: "CA" },
  "oceanside": { name: "Oceanside", state: "CA" },
  "escondido": { name: "Escondido", state: "CA" },
  "pomona": { name: "Pomona", state: "CA" },
  "torrance": { name: "Torrance", state: "CA" },
  "pasadena-ca": { name: "Pasadena", state: "CA" },
  "orange": { name: "Orange", state: "CA" },
  "fullerton": { name: "Fullerton", state: "CA" },
  "anaheim": { name: "Anaheim", state: "CA" },
  "lancaster-ca": { name: "Lancaster", state: "CA" },
  "palmdale": { name: "Palmdale", state: "CA" },
  "corona": { name: "Corona", state: "CA" },
  "sunnyvale": { name: "Sunnyvale", state: "CA" },
  "concord-ca": { name: "Concord", state: "CA" },
  "hayward": { name: "Hayward", state: "CA" },
  "aurora-il": { name: "Aurora", state: "IL" },
  "naperville": { name: "Naperville", state: "IL" },
  "joliet": { name: "Joliet", state: "IL" },
  "rockford": { name: "Rockford", state: "IL" },
  "mcallen": { name: "McAllen", state: "TX" },
  "killeen": { name: "Killeen", state: "TX" },
  "brownsville": { name: "Brownsville", state: "TX" },
  "amarillo": { name: "Amarillo", state: "TX" },
  "waco": { name: "Waco", state: "TX" },
  "midland-tx": { name: "Midland", state: "TX" },
  "beaumont": { name: "Beaumont", state: "TX" },
  "mobile": { name: "Mobile", state: "AL" },
  "montgomery": { name: "Montgomery", state: "AL" },
  "birmingham": { name: "Birmingham", state: "AL" },
  "jackson-ms": { name: "Jackson", state: "MS" },
  "columbia-sc": { name: "Columbia", state: "SC" },
  "charleston-sc": { name: "Charleston", state: "SC" },
  "savannah": { name: "Savannah", state: "GA" },
  "augusta": { name: "Augusta", state: "GA" },
  "columbus-ga": { name: "Columbus", state: "GA" },
  "macon": { name: "Macon", state: "GA" },
  "tacoma": { name: "Tacoma", state: "WA" },
  "bellevue-wa": { name: "Bellevue", state: "WA" },
  "kent": { name: "Kent", state: "WA" },
  "reno": { name: "Reno", state: "NV" },
  "henderson-nv": { name: "Henderson", state: "NV" },
  "north-las-vegas": { name: "North Las Vegas", state: "NV" },
  "paradise": { name: "Paradise", state: "NV" },
  "aurora-co": { name: "Aurora", state: "CO" },
  "lakewood-co": { name: "Lakewood", state: "CO" },
  "thornton": { name: "Thornton", state: "CO" },
  "arvada": { name: "Arvada", state: "CO" },
  "westminster-co": { name: "Westminster", state: "CO" },
  "pueblo": { name: "Pueblo", state: "CO" },
}

export function tradeLabel(slug: string): string {
  return TRADES[slug] ?? slug
}

/** Simple pluralization for trade labels used in directory headings. */
export function tradePlural(label: string): string {
  if (label.endsWith("y") && !label.endsWith("ey")) {
    return label.slice(0, -1) + "ies" // "Construction Company" → "Construction Companies"
  }
  if (label.endsWith("s")) return label // already plural
  return label + "s"
}

export function locationLabel(slug: string): string {
  const loc = LOCATIONS[slug]
  return loc ? `${loc.name}, ${loc.state}` : slug
}
